import { useMutation } from '@tanstack/react-query';

import { SubscriptionsApi } from '../subscriptions.api';

export const useCheckoutSubscription = () => {
  return useMutation({
    mutationFn: SubscriptionsApi.subscriptionCheckout,
  });
};
